
















































import HasTaskMixin from '../../components/HasTaskMixin';
import { ParentAccount } from '../../types';
import repository from '../account-repository';
import AccountLogo from './AccountLogo.vue';
import eventBus from '../../messaging/event-bus';
import { AccountLogoUploaded } from '../../messaging/events';

interface Data {
  parentAccount: ParentAccount|null,
}

export default HasTaskMixin.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    hideNone: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      parentAccount: null,
    };
  },
  computed: {
    cssClass(): string[] {
      return [
        `account-logo--${this.size}`,
      ];
    },
    hasLogo(): boolean {
      return (this.parentAccount !== null && this.parentAccount.logoUrl !== null);
    },
    show(): boolean {
      if (this.isLoading) return false;
      if (this.hasLogo) return true;
      return !this.hideNone;
    },
  },
  methods: {
    load(): void {
      this.task = repository.getParent(this.accountId);
      this.task.then((parentAccount: ParentAccount) => {
        this.parentAccount = parentAccount;
      });
    },
    onLogoUploaded(event: AccountLogoUploaded): void {
      if (this.parentAccount && this.parentAccount.id === event.accountId) {
        this.parentAccount.logoUrl = event.logoUrl;
      }
    },
  },
  created(): void {
    this.load();
    eventBus.$on(AccountLogoUploaded.eventName, this.onLogoUploaded);
  },
  beforeDestroy(): void {
    eventBus.$off(AccountLogoUploaded.eventName, this.onLogoUploaded);
  },
  components: {
    AccountLogo,
  },
});
